module.exports = __webpack_public_path__ + "img/ac69275.png";